module.exports = __webpack_public_path__ + "img/type--4-spans--single-lang--en.78a9cc79.jpg";